export default {
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.guide": "Poradnik Zakupowy",
  "nav.article": "Artykuły",
  "nav.safety_guide": "Poradnik Bezpieczeństwa",
  "nav.shipping_guide": "Przewodnik Wysyłki",
  "nav.beginners_guide": "Dla Początkujących",
  "nav.how_to_use": "Jak Korzystać",

  "hero.title": "Kakobuy Spreadsheet Polska – Największa Baza Produktów Kakobuy",
  "hero.subtitle": "Znajdź najlepsze produkty, popularne Kakobuy Finds oraz aktualne listy zakupowe w jednym miejscu.",
  "hero.description": "Nasz Kakobuy Spreadsheet pomaga użytkownikom z Polski odkrywać modne produkty, porównywać ceny i oszczędzać czas podczas zakupów.",
  "hero.cta_primary": "Kakobuy Spreadsheet",
  "hero.cta_secondary": "Buy It Now",
  "hero.trust_1": "Aktualizowane listy produktów",
  "hero.trust_2": "Polska instrukcja zakupów",
  "hero.trust_3": "Poradniki bezpieczeństwa",
  "hero.trust_4": "Kategorie produktów",

  "categories.title": "Przeglądaj Kategorie Produktów",
  "categories.subtitle": "Wybierz kategorię i odkryj najlepsze produkty w naszym Kakobuy Spreadsheet",
  "categories.select_placeholder": "Wybierz kategorię...",

  "why.title": "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  "why.card1_title": "Szybsze wyszukiwanie",
  "why.card1_desc": "Nie trać godzin na szukanie produktów. Wszystko masz w jednym miejscu.",
  "why.card2_title": "Gotowe kolekcje",
  "why.card2_desc": "Najpopularniejsze produkty posegregowane w przejrzysty sposób.",
  "why.card3_title": "Lepsze decyzje zakupowe",
  "why.card3_desc": "Porównuj produkty przed zakupem i wybieraj świadomie.",
  "why.card4_title": "Bezpieczniejsze zakupy",
  "why.card4_desc": "Poznaj zasady bezpiecznego korzystania z Kakobuy.",

  "how.title": "Jak działa Kakobuy Spreadsheet?",
  "how.step1": "Wybierz kategorię produktu",
  "how.step2": "Znajdź produkt",
  "how.step3": "Sprawdź informacje",
  "how.step4": "Przejdź do Kakobuy",

  "compare.title": "Kakobuy Spreadsheet vs Inne Metody",
  "compare.col1": "Metoda",
  "compare.col2": "Czas",
  "compare.col3": "Organizacja",
  "compare.col4": "Efekt",
  "compare.row1_method": "Google Search",
  "compare.row1_time": "Długi",
  "compare.row1_org": "Niska",
  "compare.row1_result": "Średni",
  "compare.row2_method": "Social Media",
  "compare.row2_time": "Średni",
  "compare.row2_org": "Brak",
  "compare.row2_result": "Losowy",
  "compare.row3_method": "Kakobuy Spreadsheet",
  "compare.row3_time": "Krótki",
  "compare.row3_org": "Wysoka",
  "compare.row3_result": "Najlepszy",

  "safety.title": "Czy Kakobuy Spreadsheet jest bezpieczny?",
  "safety.description": "Bezpieczeństwo jest najważniejsze. Dowiedz się jak rozpoznawać dobre źródła, sprawdzać produkty i unikać błędnych linków. Nasz Kakobuy Spreadsheet jest regularnie aktualizowany i weryfikowany przez społeczność użytkowników z Polski.",
  "safety.cta": "Sprawdź poradnik bezpieczeństwa",

  "article.title": "Artykuły o Kakobuy Spreadsheet",
  "article.subtitle": "Poznaj poradniki, recenzje, przewodniki i analizy dotyczące Kakobuy Spreadsheet – wszystko w jednym miejscu",

  "faq.title": "Najczęściej Zadawane Pytania",
  "faq.subtitle": "Wszystko co musisz wiedzieć o Kakobuy Spreadsheet",

  "cta_bar.title": "Gotowy aby odkryć najlepsze produkty?",
  "cta_bar.subtitle": "Przejdź do Kakobuy Spreadsheet i zacznij oszczędzać czas na zakupach już dziś.",
  "cta_bar.button": "Kakobuy Spreadsheet",
  "cta_bar.button2": "Buy It Now",

  "footer.description": "Kakobuy Spreadsheet Polska to niezależny portal edukacyjny pomagający użytkownikom z Polski w odkrywaniu produktów i bezpiecznych zakupach.",
  "footer.categories": "Kategorie",
  "footer.resources": "Zasoby",
  "footer.legal": "Informacje prawne",
  "footer.copyright": "Wszelkie prawa zastrzeżone.",
}